package style

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState


/**
 * Returns the style class for a lifecycle state
 */
fun LizergyLifeCycleState.toStyleClass(): String {
  return when (this) {
    LizergyLifeCycleState.Active -> ""
    LizergyLifeCycleState.NearEndOfLive -> "near-end-of-life"
    LizergyLifeCycleState.EndOfLife -> "end-of-life"
  }

}
